import type { ImportQueueItem } from '../types/import-queue-item';

export function filterImportQueueItems(
  items: ImportQueueItem[],
  options: {
    hideCompleted: boolean;
    failedOnly?: boolean;
    dismissedIds?: ReadonlySet<string>;
  }
): ImportQueueItem[] {
  return items.filter(item => {
    if (
      options.dismissedIds?.has(item.clientId) ||
      (item.navigationId && options.dismissedIds?.has(item.navigationId))
    ) {
      return false;
    }
    if (options.hideCompleted && item.status === 'done') {
      return false;
    }
    if (options.failedOnly && item.status !== 'failed') {
      return false;
    }
    return true;
  });
}
